import React, { Component } from 'react';
import styled from 'styled-components';
import Section from './Section';
import Slider from 'react-slick';
import Image1 from '../images/photos_0.jpg';
import Image2 from '../images/photos_1.jpg';
import Image3 from '../images/photos_2.jpg';
import Image4 from '../images/photos_3.jpg';
import Image5 from '../images/photos_4.jpg';
import Image6 from '../images/photos_5.jpg';
import Image7 from '../images/photos_6.jpg';
import Image8 from '../images/photos_7.jpg';
import Image9 from '../images/photos_8.jpg';
import Image10 from '../images/photos_9.jpg';
import Image11 from '../images/photos_10.jpg';
import Image12 from '../images/photos_11.jpg';
import { device } from '../utils/devices';


import 'slick-carousel/slick/slick.css';

const Wrapper = styled.div`

  .slick-arrow {
    display: none !important;

    @media ${device.laptop} {
      display: block !important;
    }
  }

  .slick-dots {
    display: none !important;

    @media ${device.laptop} {
      display: block !important;
    }
  }


  @media ${device.laptop} {
    // height: 55vw;
    // overflow: hidden;
  }

`;

const Slide = styled.div`


  @media ${device.laptop} {
    width: 100%;
    height: 50vw;
    display: flex !important;
    justify-content: center;
    align-items: center;
    background: ${props => props.theme.light}
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media ${device.laptop} {
    height: 40vw;
    object-fit: contain;
  }
`;

export default class Photos extends Component {
  render(){
    var settings = {
      dots: true,
      speed: 500,
      slidesToScroll: 1,
    };

    return (
      <Section title='Photos' left={this.props.left}>
        <Wrapper className="test">
          <Slider {...settings}>
            <Slide><Image src={Image8}/></Slide>
            <Slide><Image src={Image1}/></Slide>
            <Slide><Image src={Image2}/></Slide>
            <Slide><Image src={Image3}/></Slide>
            <Slide><Image src={Image4}/></Slide>
            <Slide><Image src={Image5}/></Slide>
            <Slide><Image src={Image6}/></Slide>
            <Slide><Image src={Image7}/></Slide>
            <Slide><Image src={Image9}/></Slide>
            <Slide><Image src={Image10}/></Slide>
            <Slide><Image src={Image11}/></Slide>
            <Slide><Image src={Image12}/></Slide>
          </Slider>
        </Wrapper>
      </Section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Photos.js